module.exports = __webpack_public_path__ + "img/my_number_upload.1d6dac2b.png";